module.exports = __webpack_public_path__ + "static/media/Sec-1_Home_CN.42eea551.webp";